import { Component, Input, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { DataService } from 'src/app/services/data.service';

@Component({
  selector: 'app-form-submission',
  templateUrl: './form-submission.page.html',
  styleUrls: ['./form-submission.page.scss'],
})
export class FormSubmissionPage implements OnInit {
  @Input() results;
  constructor(
    private modalCtrl:ModalController,
    public dataSRV:DataService,
  ) { }

  ngOnInit() {
   this.results.forEach(formElement => {
    if(formElement['type']=='select' || formElement['type']=='radio-group' || formElement['type']=='checkbox-group' || formElement['type']=='autocomplete'){
      var tempArray=[]
      formElement['values'].forEach(element => {
        if(element['selected']==true){
          tempArray.push(element['label'])
        }
      });
      formElement['value']=tempArray.toString()
    }
   });
    
    
  }
  closeModal() {
    this.modalCtrl.dismiss();
  }

}
